// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"72":"bf3bc070","114":"61031774","298":"d15fa54a","388":"ca6ef5b2","497":"227df0cc","583":"93c8f0bb","612":"8427ad36","656":"3b69bc07","703":"858716f4","824":"1af29543","852":"174ac362"}[chunkId] + ".js";
};